<mat-form-field class="flow-locale-select">
  <textarea
    matInput
    [formControl]="localesControl"  
    (blur)="changeInput()"
    cdkTextareaAutosize 
    cdkAutosizeMinRows="1" 
    cdkAutosizeMaxRows="10" 
  ></textarea> 

  @if (localesControl.hasError('required') || localesControl.hasError('reviewRequired')) {
    <mat-error>
      {{ (localesControl.hasError('reviewRequired') ? "flowsLocalizationPage.validationErrors.updated" : '') | translate }}
    </mat-error>
  }
</mat-form-field>
